import { createRoute, Outlet } from "@tanstack/react-router";
import { appLayoutRoute } from "@/routes/layout-routes";
import { BlogPostListScreen } from "@/app/Blogs/Screens/BlogPostListScreen";
import { BlogPostEditScreen } from "@/app/Blogs/Screens/BlogPostEditScreen";
import { BlogPostTranslationsScreen } from "@/app/Blogs/Screens/BlogPostTranslationsScreen";
import { BlogPostRecordScreen } from "@/app/Blogs/Screens/BlogPostRecordScreen";
import { BlogAuthorsScreen } from "@/app/Blogs/Screens/BlogAuthorsScreen";
import { BlogTagsScreen } from "@/app/Blogs/Screens/BlogTagsScreen";
import { fetchQuery } from "@/lib/GraphQLCodegen/fetcher";
import { blogPostRecordQuery } from "@/app/Blogs/GraphQL/blogPostRecordQuery";

export const blogPostsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/blogs",
  component: Outlet,
  head: () => ({
    meta: [
      { title: "Blog posts - Imoova Admin" },
      { name: "description", content: "Manage blog posts" },
    ],
  }),
});

export const blogPostListRoute = createRoute({
  getParentRoute: () => blogPostsRoute,
  path: "/",
  component: BlogPostListScreen,
});

export const blogPostRoute = createRoute({
  getParentRoute: () => blogPostsRoute,
  path: "$id",
  component: BlogPostRecordScreen,
  loader: ({ params }) => {
    return fetchQuery(blogPostRecordQuery, { id: params.id }, params.orgId);
  },
});

export const blogPostEditRoute = createRoute({
  getParentRoute: () => blogPostRoute,
  path: "/",
  component: BlogPostEditScreen,
});

export const blogPostTranslationsRoute = createRoute({
  getParentRoute: () => blogPostRoute,
  path: "translations",
  component: BlogPostTranslationsScreen,
});

export const blogAuthorsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/blog-authors",
  component: BlogAuthorsScreen,
});

export const blogTagsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/blog-tags",
  component: BlogTagsScreen,
});
